import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { User } from "../../../pages/login/login.model";
import superAdminLoginService from "./superAdminLoginService";

interface SuperAdminLoginRecoverState {
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
  superAdminLoginRecoverData: any;
}

const initialState: SuperAdminLoginRecoverState = {
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  superAdminLoginRecoverData: "",
};

//login recover slice - forgot username & forgot password
export const superAdminLoginRecover = createAsyncThunk("auth/recover-login", async (userData: User, thunkAPI) => {
  try {
    const response = await superAdminLoginService.superAdminLoginRecoverService(userData);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const SuperAdminLoginRecoverSlice = createSlice({
  name: "loginRecover",
  initialState,
  reducers: {
    superAdminResetLoginRecover: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminLoginRecover.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(superAdminLoginRecover.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.superAdminLoginRecoverData = action.payload;
      })
      .addCase(superAdminLoginRecover.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { superAdminResetLoginRecover } = SuperAdminLoginRecoverSlice.actions;
